import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "star", "display"]
  static values = { 
    value: { type: Number, default: 0 },
    max: { type: Number, default: 5 },
    disabled: { type: Boolean, default: false }
  }

  connect() {
    this.updateUI()
  }

  setRating(event) {
    if (this.disabledValue) return

    const rating = parseInt(event.currentTarget.dataset.ratingValue, 10)
    
    // Allow clearing by clicking the same star
    if (rating === this.valueValue) {
      this.valueValue = 0
    } else {
      this.valueValue = rating
    }

    this.updateUI()
    
    if (this.hasInputTarget) {
      this.inputTarget.value = this.valueValue
      this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  updateUI() {
    this.starTargets.forEach((star) => {
      const starIndex = parseInt(star.dataset.starIndex, 10)
      if (starIndex <= this.valueValue) {
        star.classList.remove("text-gray-300")
        star.classList.add("text-yellow-400")
      } else {
        star.classList.remove("text-yellow-400")
        star.classList.add("text-gray-300")
      }
    })

    if (this.hasDisplayTarget) {
      if (this.valueValue > 0) {
        this.displayTarget.textContent = `${this.valueValue} / ${this.maxValue}`
      } else {
        this.displayTarget.textContent = "Not rated"
      }
    }
  }
}
